import * as yup from 'yup';

import { checkUsername } from '../../../utils/backend-api/profileSettings';

const ProfileSchema = () =>
  yup.object().shape({
    username: yup
      .string()
      .min(3, 'Must be at least three characters')
      .max(20, 'Must be 20 characters or less')
      .required('Username is required')
      .matches(/^[a-z0-9_]+$/, 'Must be all lowercase and include no special characters')
      .test('Unique Username', 'username already in use', async (value) => {
        const res = await checkUsername({ username: value });
        return res.success;
      }),
    oneLineBio: yup.string().max(40, 'Must be 40 characters or less').nullable(),
    company: yup
      .object()
      .shape({
        label: yup.string(),
        value: yup.string(),
      })
      .nullable(),
    title: yup
      .object()
      .shape({
        label: yup.string(),
        value: yup.string(),
      })
      .nullable(),
    location: yup
      .object()
      .shape({
        label: yup.string(),
        value: yup.string(),
      })
      .nullable(),
    bio: yup.string().nullable(),
    shortBio: yup.string().nullable(),
  });

export default ProfileSchema;
